namespace CMS {
    interface HeroCard {
        name: string;
        url: string;
        header: string;
        linkUrl?: string | null;
    }
    interface MobileHero {
        elements: string;
        area: string;
        heroes: HeroCard[];
        currentArea: string;
        heroStyle: any;
        sale: string;
        showHero: any;
    }
    interface ControllerScope extends ng.IScope {
        mh: MobileHero;
    }
    interface CurrentRoute extends ng.route.ICurrentRoute {
        area: string;
    }
    interface RouteService extends ng.route.IRouteService {
        current: CurrentRoute;
    }

    angular
        .module('cms')
        .component('mobileHero', {
            bindings: {
                elements: '@',
                heroStyle: '=',
                sale: '=',
            },
            controller: function ($scope: ControllerScope, $route: RouteService) {
                const scope : MobileHero = $scope.mh;
                scope.showHero = (name: string) : boolean => {
                    const supportsHeroStyle = ['hotels', 'holidays'].indexOf(name) >= 0;
                    const supportsSalesStyle = ['hotels', 'holidays'].indexOf(name) >= 0;

                    if (supportsHeroStyle && scope.heroStyle && scope.heroStyle['background-image'] !== '') {
                        return false;
                    } else if (supportsSalesStyle && scope.sale && scope.sale !== '') {
                        return false;
                    }

                    return true;
                };

                scope.currentArea = $route.current.area && $route.current.area.toLowerCase();

                const supportedProducts = TRPCONFIG.Domain.SupportedProductNames.map(p => p.toLowerCase());
                try {
                    const heroes = JSON.parse(scope.elements);
                    const heroKeys = _.keys(heroes);
                    this.heroes = [];
                    heroKeys.forEach(elem =>{
                        const url = _.get(heroes, `${elem}`, null);
                        const header = _.get(heroes, `${elem}Header`, '');
                        const linkUrl = _.get(heroes, `${elem}LinkUrl`, '');
                        let name = elem.toLowerCase();
                        if (_.isString(url) && url.replace(/\s+/,'').length > 0  &&
                            supportedProducts.indexOf(name) >= 0 &&
                            scope.currentArea === name &&
                            scope.showHero(name)) {
                            scope.heroes.push({ name, url, header, linkUrl });
                        }
                    });
                } catch (e) { }
            },
            controllerAs: 'mh',
            template: `
            <div
                ng-repeat="hero in mh.heroes track by $index"
                class="sc-c-superhero"
            >
            <a href={{hero.linkUrl}} tabindex="0" style="
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 2;
            "></a>
                <div class="sc-c-superhero-slide">
                    <img 
                        class="sc-c-superhero-slide__image"
                        src="{{hero.url}}"
                    >
                </div>
                <div ng-if="hero.header.length > 0"
                    class="sc-c-container sc-c-container--gutters-x">
                    <div class="sc-c-superhero__headline">
                        <h1>{{hero.header}}</h1>
                    </div>
                </div>
            </div>
            `
        });
}
